<template>
    <div id="app">
        <div
            class="main-content"
            :class="
                $route.meta.showSideBar == false ? 'content-full-width' : ''
            "
        >
            <base-sidebar
                v-if="$route.meta.showSideBar"
                :class="sidebarResponsive == true ? 'show-sidebar' : ''"
                @onClick="sidebarResponsive = false"
                @closeSidemenu="closeSidebar"
            ></base-sidebar>
            <router-view @responsiveSideBar="sidebarResponsive ^= true" />
            <base-toast></base-toast>
        </div>
        <notification-popup
                title="Alert"
                description="Your session is about to expire. To remain logged in, please click OK within the next 15 minutes"
                :onConfirm="increaseSessionTime" >
        </notification-popup>
    </div>
</template>

<style lang="scss">
@import 'assets/scss/app.scss';
</style>
<style type="text/css">
:root {
    --primary-color: var(--primary-color);
    --secondary-color: var(--secondary-color);
    --interface-medium-color: var(--interface-medium-color);
    --interface-dark-color: var(--interface-dark-color);
}
</style>
<script>
    import NotificationPopup from "./components/popups/NotificationPopup";
    import request from '@/utils/request'

    export default {
    components: {
        NotificationPopup,
    },
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            sidebarResponsive: false,
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {}, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        this.checkTokenExpiry();
        this.getPublicIP();

        // Periodically check token expiry
        setInterval(this.checkTokenExpiry, 60 * 1000);
    }, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        closeSidebar() {
            this.sidebarResponsive = false
        },
        checkTokenExpiry() {
            if(localStorage.getItem('vueauth_token') && localStorage.getItem('vueauth_token_expiry'))
            {
                const tokenExpiry = localStorage.getItem('vueauth_token_expiry')
                const currentTime = new Date().getTime();
                const expiryTime = new Date(tokenExpiry).getTime();
                const timeRemaining = expiryTime - currentTime;
                const differenceInMinutes = timeRemaining / (1000 * 60);
                const timeToCheck = 14 * 60 * 1000
                const timeToCheck1 = 16 * 60 * 1000

                // console.log('Current--',new Date())
                // console.log('tokenExpiry--',new Date(tokenExpiry))
                // console.log('time remaining--',timeRemaining)
                // console.log('timeToCheck--',timeToCheck)
                // console.log('timeToCheck1--',timeToCheck1)
                // console.log('timeLeft in minutes--',differenceInMinutes)

                if (timeRemaining >= timeToCheck && timeRemaining <= timeToCheck1) {
                    this.$bvModal.show('notification-popup');
                    // alert("Your session is about to expire. To continue using the application seamlessly, please refresh your session within the next 15 minutes");
                }
            }
        },
        async increaseSessionTime(){
            try{
                this.$store.commit('setLoading',true)

                let {data} = await request.get('users/sessionUpdate')

                // console.log('return of data-----',data)
                if(data && data.status)
                {
                    this.$store.commit('setSuccess', data.message)
                    this.$store.commit('setTokenExpiry', data.data.expiresIn)
                }
                else
                {
                    // console.log('response---',data.message)
                    this.$store.commit('setError',"Something went wrong, please try again later")
                }

                this.$store.commit('setLoading',false)
                // this.$refs.modal.hide()
                this.$bvModal.hide('notification-popup');


            }catch(error){
                console.log(error)
                // this.$refs.modal.hide()
                this.$bvModal.hide('notification-popup');

                this.$store.commit('setError', errors)
                this.$store.commit('setLoading',false)
            }
        },
        async getPublicIP(){
            try{
                const {data} = await this.axios.get('https://api.ipify.org?format=json')
                this.$store.commit("setUserIp", data.ip);
                this.$store.commit("setIp", data.ip);
                this.$store.commit("setIpLocationDetails", {ip: data.ip});

                if(data.ip) {
                    this.getLocationDetails(data.ip);
                }

            }catch(e) {
                console.log("error in getPublicIP", e);
            }
        },
        async getLocationDetails(ip){
            try{
                const {data} = await this.axios.get('http://ip-api.com/json/'+ip)

                this.$store.commit("setIpLocationDetails", {...data, ip: ip});

            }catch(e) {
                console.log("error in getLocationDetails", e);
            }
        },

    }, // End of Component > mounted
} // End of export default
</script>
